import { eventBus, EVENTS } from '../commons/EventBus.js';
const playingClass = 'is-playing';
let initialized = false;
let cover_to_overlay = "";
eventBus.on(EVENTS.PAGE_AFTER_RENDERING, function (data) {
    // const template=data.template;
    if (!initialized) {
        initPlayer();
        initialized = true;
    }
});



function initPlayer() {

    eventBus.on(EVENTS.PLAYER_PODCAST_NEW_SONG, function (podcast) {
        if(playerPodcast.waitPreroll){
            return;
        }

        $(".player_bottom_like.container_set_preferito").find(".set_preferiti").removeClass("liked");
        $("#bottom_player_categoria").text(podcast["categoria"]);
        $("#bottom_player_titolo").text(podcast["titolo"]);
        $("#bottom_player_orario").text(podcast["giorno"]);
        $("#bottom_player_cover").attr("src", podcast["immagine"]);
        $(".player_bottom_like.container_set_preferito").attr("data-id", podcast["id"]);
        $(".player_bottom_like.container_set_preferito").attr("data-type", podcast["type"]);
        $(".player_bottom_like.container_set_preferito").attr("data-masterID", podcast["master_id"]);
        $("#condividi_episodio").off("click").click(function(){
            const url = `${location.protocol}//${location.host}${podcast["slug"]}`;
            facebookShare({img: podcast["immagine"], title: podcast["titolo"], caption: 'x', url: url})
        });

        $("#category_title_ext").text(podcast["categoria"]);
        $("#img_category_ext").attr("src", podcast["immagine"]);

        window.setMyFavorite();
        // $(".player_bottom_like.container_set_preferito[data-id='" + podcast["id"] + "'][data-type='" + podcast["type"] + "']").find(".set_preferiti").addClass("liked");

        try {
            //provato a toglierlo per safari
            // $(".time_left").text(`- ${Math.floor(playerPodcast.getDuration())}`);

        } catch (error) {

        }
        // $(".time_left").text("- "+$( playerPodcast.container +' video')[0].duration);

        cover_to_overlay = podcast["cover_to_overlay"];
        if (podcast.type == 'video') {

        }


    });

    playerPodcast.on('timeupdate', function () {
        var iNow = playerPodcast.player.currentTime();
        var countdown = (playerPodcast.getDuration() || 0) - iNow;
        // $(".time_left").text("- "+countdown);
        $(".time_left").text("- " + getTime(Math.floor(countdown)));

        var width_timeline = 100 / playerPodcast.getDuration() * iNow;
        $("#timeline_bottom").css("width", width_timeline+"%");
    });

    playerPodcast.on('resume', () => {        
        $("#player_bottom_play").addClass("is_playing");           
        // $(".cover_overlay").removeClass("overlay_playing_red");
        // $(cover_to_overlay).addClass("overlay_playing_red");

    });
    playerPodcast.on('pause', () => {
        $("#player_bottom_play").removeClass("is_playing");
        // $(".cover_overlay").removeClass("overlay_playing_red");
    });

    videoPlayer.on('resume', () => {
        $("#player_bottom_play").addClass("is_playing");
        // $(".cover_overlay").removeClass("overlay_playing_red");
        // $(cover_to_overlay).addClass("overlay_playing_red");
        $('#videoplayer').show();
    });
    videoPlayer.on('pause', () => {
        $("#player_bottom_play").removeClass("is_playing");
        // $(".cover_overlay").removeClass("overlay_playing_red");
    });
    videoPlayer.on('timeupdate', function () {
        var iNow = playerPodcast.player.currentTime();
        var countdown = (playerPodcast.getDuration() || 0) - iNow;
        // $(".time_left").text("- "+countdown);
        $(".time_left").text("- " + getTime(Math.floor(countdown)));
    });

}


$(document).on("click", "#player_bottom_play", function () {

    if ($(this).hasClass("is_playing")) {
        playerPodcast.pause();
    } else {
        playerPodcast.play();
    }
});

$(document).on("click", "#toggle_volume", function () {

    if (playerPodcast.player.volume() == 1) {
        playerPodcast.player.volume(0);
        $(this).addClass("no_volume");
        return;
    } else {
        playerPodcast.player.volume(1);
        $(this).removeClass("no_volume");
        return;
    }
});

$(document).on("click", "#forward_15", function () {
    playerPodcast.currentTime(playerPodcast.currentTime() + 15);
    $(playerPodcast.container + ' video')[0].currentTime += 15

});

$(document).on("click", "#back_15", function () {
    playerPodcast.currentTime(playerPodcast.currentTime() - 15);
});

function getTime(time_seconds) {
    var minutes = Math.floor(time_seconds / 60);
    var seconds = time_seconds - minutes * 60;

    var hours = Math.floor(time_seconds / 3600);
    var time = time_seconds - hours * 3600;

    return str_pad_left(minutes, '0', 2) + ':' + str_pad_left(seconds, '0', 2);
}

function str_pad_left(string, pad, length) {
    return (new Array(length + 1).join(pad) + string).slice(-length);
}

function openPlayerBottom(type) {
    console.log('type',type);
    console.log('!$("#player_bottom").is(":visible")',!$("#player_bottom").is(":visible"));
    // if(window.innerWidth > 900){
    if(!$("#player_bottom").is(":visible")){
        closeExtPlayer();
    }
    if (type=="podcast-video" || type=="gioco-video")  {
        openVideoPlayer();
    }
    $('body').addClass('playing-bottom-player');
    $("#player_bottom").fadeIn();
}

function openVideoPlayer() { 
    $("#play_bottom_left").removeClass("giochi-padding_left")
    if(window.location.pathname == "/giochi/rds-galbanino-palcosanremo"){
        $("#play_bottom_left").addClass("giochi-padding_left")
    } 
    $(playerPodcast.container.parentElement).show();
    $(playerPodcast.container).show();
    $('#full_player_bottom').addClass('is-video');
    $("#full_player_bottom").show();
    $("#full_player_bottom_inter").slideDown();
    $(".extend_player").addClass("close_player");
    $(".extend_player.close_player").find("span").html("CHIUDI");
}
function closeVideoPlayer() {
    $(playerPodcast.container.parentElement).hide();
    $(playerPodcast.container).hide();
    $(playerPodcast.container.parentElement).hide();
    $(playerPodcast.container).hide();
    $('#full_player_bottom').removeClass('is-video');
    $("#full_player_bottom_inter").slideUp();
    $('#full_player_bottom').hide();
}

function openExtPlayer() {
    $("#full_player_bottom").show();
    $("#full_player_bottom_inter").show();
    $(".extend_player").addClass("close_player");
    $(".extend_player.close_player").find("span").text("CHIUDI");


    if($("#playing_podcast_extended").is(":visible")) {
        putCurrentInMiddle();
    }

    ////Rivedere in base alla skin, questa è una fix momentanea probabilmente
    if(getComputedStyle(document.documentElement).getPropertyValue("--cur-scroll") == 0 && $(".rds-container").css("margin-top") == "90px"){

        $("#full_player_bottom").css("height", "calc(100vh - 200px)");
    } else{
        $("#full_player_bottom").css("height", "calc(100vh - 110px)");
    }

    $("html").css("overflow", "hidden");

}

function closeExtPlayer() {
    $("#full_player_bottom").hide();
    $("#full_player_bottom_inter").hide();
    $(".extend_player").removeClass("close_player");
    $(".extend_player").find("span").text("APRI");
    $("html").css("overflow", "auto");
}

$(document).on({
    click: function () {
        openExtPlayer();
    }
}, ".extend_player:not(.close_player)");

$(document).on({
    click: function () {
        if($("#playing_podcast_extended").is(":visible")) {
          putCurrentInMiddle();
        }
        closeExtPlayer();
    }
}, ".close_player.extend_player");

$(document).on({
    click: function () {         
        if(window.location.pathname == "/giochi/rds-galbanino-palcosanremo"){
            $("#play_bottom_left").removeClass("giochi-padding_left")
        } 
        $("#player_bottom").fadeOut();
        $("#podcast_append").empty();
        $("html").css("overflow", "auto");
        $("#collapsed_player_bottom").find(".container_blue_action_all").hide();
        $('body').removeClass('playing-bottom-player');
    }
}, "#close_bottom_player");

function putCurrentInMiddle(){

    if(window.innerWidth <= 550){
        $(".other_podcast").css("display", "flex");
        $("#podcast_append").animate({
            scrollTop: $(".current_pod").offset().top - $("#podcast_append").offset().top + $("#podcast_append").scrollTop()
        });
    } else{

        // $('#podcast_append').animate({scrollTop:240}, 1000);
        var index_current=$(".current_pod").index();
        $(".other_podcast").hide();
        if(index_current>=2){
            $(".other_podcast").eq(index_current-1).css("display", "flex");
            $(".other_podcast").eq(index_current-2).css("display", "flex");
        } else if(index_current==1){
            $(".other_podcast").eq(index_current-1).css("display", "flex");
        }
        $(".current_pod").show();
        $(".current_pod").nextAll(".other_podcast").css("display", "flex");
    }
}





function scrollElementPlay(){
    if(window.innerWidth <= 550){
        $(".other_podcast").css("display", "flex");

    } else if(window.innerWidth <= 550){
        $(".other_podcast").removeClass("current_pod");
        $(".other_podcast").removeClass("prev_pod");
        $(".other_podcast").removeClass("next_pod");
        $("#podcast_append").find(".podcast-play.is-playing").parents(".other_podcast").addClass("current_pod").css("display","flex");
        $(".current_pod").prevAll().addClass("prev_pod");
        $(".current_pod").nextAll().addClass("next_pod");
    } else {
        // $(".other_podcast").hide();
        $(".other_podcast").removeClass("current_pod");
        $(".other_podcast").removeClass("prev_pod");
        $(".other_podcast").removeClass("next_pod");
        $("#podcast_append").find(".podcast-play.is-playing").parents(".other_podcast").addClass("current_pod").css("display","flex");
        $(".current_pod").prevAll().addClass("prev_pod");
        $(".current_pod").nextAll().addClass("next_pod");
    }
    // showCurrentPrevNext();
}

$(document).on("click", ".title_podcast_other", function(){

    $(this).parents(".other_podcast").find(".podcast-play").trigger("click");

});
// other_podcast

window.openPlayerBottom = openPlayerBottom;
window.openVideoPlayer = openVideoPlayer;
window.openExtPlayer = openExtPlayer;
